import {
    StyleSheet
} from "react-native";
import type {
    StatTileDeltaDirectionConstantType,
    StatTileDeltaDynamicStyleType,
    StatTileDeltaBadgeType,
    StatTileDeltaDirection
} from "./type";

export const STAT_TILE_DELTA_EPSILON = 1e-9;

export const STAT_TILE_DELTA_FRACTION_DIGITS = 1;

export const getStatTileDeltaDirection = ({
    value
}: Pick<StatTileDeltaDirectionConstantType, "value">): StatTileDeltaDirection => {
    if(Math.abs(value) < STAT_TILE_DELTA_EPSILON) {
        return "unchanged";
    }

    return value > 0 ? "increase" : "decrease";
};

export const getStatTileDeltaType = ({
    isIncreaseGood,
    value
}: StatTileDeltaDirectionConstantType): StatTileDeltaBadgeType => {
    const direction = getStatTileDeltaDirection({
        value
    });

    if(direction === "unchanged") {
        return "neutral";
    }

    return (direction === "increase") === isIncreaseGood ? "success" : "danger";
};

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    badge: {
        fontVariant: [
            "tabular-nums"
        ]
    },
    description: {
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: StatTileDeltaDynamicStyleType) => {
    const styles = {
        container: {
            columnGap: spaces.spacingSm,
            rowGap: spaces.spacingXs
        }
    };

    return styles;
};
export default stylesheet;
